/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SetLoyaltyPointsRequestContent
 */
export interface SetLoyaltyPointsRequestContent {
    /**
     * 
     * @type {number}
     * @memberof SetLoyaltyPointsRequestContent
     */
    points?: number;
    /**
     * 
     * @type {string}
     * @memberof SetLoyaltyPointsRequestContent
     */
    reason?: string;
}


/**
 * Check if a given object implements the SetLoyaltyPointsRequestContent interface.
 */
export function instanceOfSetLoyaltyPointsRequestContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SetLoyaltyPointsRequestContentFromJSON(json: any): SetLoyaltyPointsRequestContent {
    return SetLoyaltyPointsRequestContentFromJSONTyped(json, false);
}

export function SetLoyaltyPointsRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLoyaltyPointsRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'points': !exists(json, 'points') ? undefined : json['points'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function SetLoyaltyPointsRequestContentToJSON(value?: SetLoyaltyPointsRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'points': value.points,
        'reason': value.reason,
    };
}

